import { getColors } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {ListChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'project_status',
    resource: {
      endpoint: 'total_by_status_room_propertytype',
      filter: {
        'filter.statuses': ['sold', 'reserved', 'sale'],
      },
    },
    type: 'List',
    title: {
      id: 'priceTotal',
      label: `${context.$tc('project', 1)}${context.$t('status').toLowerCase()} *`,
      style: true,
    },
    footer: `* ${context.$t('included')} ${context.getTranslation(['plot', 'leisurePlot'], ', ').toLowerCase()}`,
    dimensions: ['averageSquarePrice', 'priceTotal', 'count'].map(dimension => ({
      id: dimension,
      label: context.getTranslation(dimension),
      style: '',
      icon: '',
      value: ({ data, item }) => {
        return context.valueParser(data.data[item.id].total[dimension])
      },
    })),
    data: ({ data = {}, colors = {} }) =>
      data && data.keys
        ? data.keys
            .map(key => {
              return data.data && data.data[key] && data.data[key].total
                ? {
                    id: key,
                    label: context.getTranslation(key),
                    style: '',
                    icon: '',
                    marker: colors[key],
                  }
                : null
            })
            .filter(Boolean)
        : [],
    colors: ({ data = {} }) => getColors(data.keys, true),
  }
}
